<!-- Select type -->

<div class="row">
  <app-cms-page-content [pageId]="'financial_page_text'" [showNotFound]="false" class="col-12 col-md-4 order-md-1 pt-sm-2"></app-cms-page-content>
  <div class="col-12 col-md-8 pt-0">
    <app-select-financial-type [(type)]="type" #financialType (typeChange)="typeChanged($event)">
    </app-select-financial-type>
  </div>
</div>


<!-- Open orders -->
@if (financialType.type === 'openorders') {
  <app-open-orders
    [navigationObserver]="navigationChangeEmitted$" [shippingAddressGroup]="shippingAddressGroup"
    [type]="financialType.type">
  </app-open-orders>
}

<!-- Invoices -->
@if (financialType.type === 'invoices') {
  <app-invoices
    [shippingAddressGroup]="shippingAddressGroup"
    [type]="financialType.type"
    [onlinePaymentRestrictionLevel]="onlinePaymentRestrictionLevel">
    <!-- Number of results -->
    <div class="numResults">
      @if (financialType.type === 'invoices') {
        <app-invoice-balance-overview
        [numResults]="pageData.numResults['invoices']"></app-invoice-balance-overview>
      }
    </div>
  </app-invoices>
}

@if (financialType.type === 'credit') {
  <app-invoices
    [shippingAddressGroup]="shippingAddressGroup"
    [type]="financialType.type"
    [onlinePaymentRestrictionLevel]="onlinePaymentRestrictionLevel">
    <!-- Number of results -->
    <div class="numResults">
      @if (financialType.type === 'invoices') {
        <app-invoice-balance-overview
        [numResults]="pageData.numResults['invoices']"></app-invoice-balance-overview>
      }
    </div>
  </app-invoices>
}

@if (financialType.type === 'balance') {
  <app-balance>
  </app-balance>
}

@if (financialType.type === 'sent_orders') {
  <app-baskets [type]="'sent'" [hideHeader]="true"  [basePage]="'financial'"></app-baskets>
}


<!-- Packingslips -->
@if (financialType.type === 'packingslips') {
  <app-packing-slips [type]="financialType.type"
  [shippingAddressGroup]="shippingAddressGroup"></app-packing-slips>
}
